import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { jsx as _jsx } from "react/jsx-runtime";
function CustomCodeActionSummary() {
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "automation-ui-action-features.action-features.custom-code.summary_jsx",
    elements: {
      Bold: 'strong'
    }
  });
}
export default CustomCodeActionSummary;